/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex, axios)

export default new Vuex.Store({
   state:{
         isLoggedIn: !!localStorage.getItem('token'),
         departmentItem:[],
         positionsItem:[],
         subDepartmentItem:[],

         aniversaryAll:[],
         employeeLeave:[],
         birthdayAll:[],
         incommingLeave:[],
         statusItem:[],
         timezoneItem:[],
   },

   getters:{

   },

   actions:{
       //DROPDOWN
        GET_DEPARTMENT: async ({commit}) => {
            let { data } = await axios.get(`api/departments`)
            commit('SET_DEPARTMENT', data)
        },

        GET_POSITIONS: async ({commit}) => {
            let { data } = await axios.get(`api/employeepositions`)
            commit('SET_POSITIONS', data)
        },

        GET_SUBDEPARTMENT: async ({commit}) => {
            let { data } = await axios.get(`api/subdepartments`)
            commit('SET_SUBDEPARTMENT', data)
        },

        GET_TIMEZONES: async ({commit}) => {
            let { data } = await axios.get(`api/timezones`)
            commit('SET_TIMEZONES', data)
        },


        //FOR DASHBOARD
        GET_ANNIVERSARRY_ALL: async ({commit}) => {
            let { data } = await axios.get(`api/anniversary/all`)
            commit('SET_ANNIVERSARRY_ALL', data)
        },

        GET_EMPLOYEE_LEAVE: async ({commit}) => {
            let { data } = await axios.get(`api/employee/leave`)
            commit('SET_EMPLOYEE_LEAVE', data)
        },

        GET_EMPLOYEE_BIRTHDAY: async ({commit}) => {
            let { data } = await axios.get(`api/celebrant`)
            commit('SET_EMPLOYEE_BIRTHDAY', data)
        },

        GET_INCOMING_LEAVE: async ({commit}) => {
            let { data } = await axios.get(`api/incomingLeave`)
            commit('SET_INCOMING_LEAVE', data)
        },

        GET_DASHBOARD_COUNTER: async ({commit}) => {
            let { data } = await axios.get(`api/dashboardCounter`)
            commit('SET_DASHBOARD_COUNTER', data)
        },
        
   },

   mutations: {

       SET_TIMEZONES: (state, payload) => {
            state.timezoneItem = payload
        },

       SET_DEPARTMENT: (state, payload) => {
            state.departmentItem = payload
       },

       SET_POSITIONS: (state, payload) => {
          state.positionsItem = payload
       },

       SET_SUBDEPARTMENT: (state, payload) => {
          state.subDepartmentItem = payload
        },

       loginUser (state) {
           state.isLoggedIn = true 
       },
       
       logOutUser (state){
           state.isLoggedIn = false 
       },

        //FOR DASHBOARD
        SET_ANNIVERSARRY_ALL: (state, payload) => {
            state.aniversaryAll = payload
        },

        SET_EMPLOYEE_LEAVE: (state, payload) => {
            state.employeeLeave = payload
        },

        SET_EMPLOYEE_BIRTHDAY: (state, payload) => {
            state.birthdayAll = payload
        },

        SET_INCOMING_LEAVE: (state, payload) => {
            state.incommingLeave = payload
        },

        SET_DASHBOARD_COUNTER: (state, payload) => {
            state.statusItem = payload
        },

   }
})


// WEBPACK FOOTER //
// ./src/store.js